import * as React from 'react';
const classNames = require('classnames');

interface Props {
	className?: string;
}

const Spinner: React.StatelessComponent<Props> = props => {
	return <span className={classNames('spinner', props.className)} />;
};

export default Spinner;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/Spinner.tsx